import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import store from "./store";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";
import { LicenseInfo } from "@mui/x-license";

const container = document.getElementById("root")!;
const root = createRoot(container);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: `${process.env.REACT_APP_USER_POOL_ID}`,
      userPoolClientId: `${process.env.REACT_APP_CLIENT_ID}`,
    },
  },
  Geo: {
    LocationService: {
      region: `${process.env.REACT_APP_AUTH_REGION}`,
    },
  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: `${process.env.REACT_APP_COOKIE_DOMAIN}`,
    secure: `${process.env.REACT_APP_COOKIE_SECURE}` === "true",
    path: `${process.env.REACT_APP_COOKIE_PATH}`,
    expires: +`${process.env.REACT_APP_COOKIE_DOMAIN}`,
  })
);

LicenseInfo.setLicenseKey(`${process.env.REACT_APP_MUI_X_LICENSE_KEY}`);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
